// The colour scheme lives on <html data-kgr-theme="dark">, set by the switch in base.html.twig.
// Components that render their own chrome (TinyMCE) read it here and follow changes.

const THEME_ATTRIBUTE = 'data-kgr-theme';

export function isDarkTheme() {
    return document.documentElement.getAttribute(THEME_ATTRIBUTE) === 'dark';
}

/**
 * Calls back with the new state whenever the theme changes; returns a function that stops watching.
 */
export function observeDarkTheme(callback) {
    const observer = new MutationObserver(() => callback(isDarkTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: [THEME_ATTRIBUTE] });

    return () => observer.disconnect();
}
